export enum Status {
  NotEligible,
  Eligible,
  Denied,
  Denied21,
}
